<template>
  <TransitionGroup
    tag="div"
    name="system-announcement"
    class="system-announcement-stack"
  >
    <SystemAnnouncementBanner
      v-for="banner in store.activeBanners"
      :key="banner.id"
      :announcement="banner"
      @dismiss="store.dismiss"
    />
  </TransitionGroup>
</template>

<script setup>
import { onMounted } from 'vue';
import { useRouter } from 'vue-router';
import { useSystemAnnouncementsStore } from '@/stores/systemAnnouncements';
import SystemAnnouncementBanner from './SystemAnnouncementBanner.vue';

const store = useSystemAnnouncementsStore();
const router = useRouter();

onMounted(() => {
  if (!store.loaded) store.fetch();
});

// Re-fetch on full-page navigations (route changes)
router.afterEach((to, from) => {
  if (to.name !== from?.name) store.fetch();
});
</script>

<style scoped>
.system-announcement-enter-active,
.system-announcement-leave-active {
  transition: opacity 250ms ease, transform 250ms ease;
}
.system-announcement-enter-from,
.system-announcement-leave-to {
  opacity: 0;
  transform: translateY(-4px);
}
</style>
